import { render, staticRenderFns } from "./MasterReservedHomeworks.vue?vue&type=template&id=2ba3bc56"
import script from "./MasterReservedHomeworks.vue?vue&type=script&lang=js"
export * from "./MasterReservedHomeworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports